//Polyfill
import "core-js";

document.addEventListener("DOMContentLoaded", () => {
  const headerBtn = document.querySelector(".header-btn");
  const headerNav = document.querySelector(".header-nav");
  const menuItems = document.querySelectorAll(".header-nav ul li a");
  const hamburgerMenu = document.querySelector(".header-nav--link--btn");

  headerBtn.addEventListener("click", () => {
    headerBtn.classList.toggle("open");
    headerNav.classList.toggle("open");
  });

  menuItems.forEach(function (item) {
    item.addEventListener("click", function () {
      closeMenu();
    });
  });

  hamburgerMenu.addEventListener("click", function () {
    closeMenu();
  });

  function closeMenu() {
    headerBtn.classList.remove("open");
    headerNav.classList.remove("open");
  }
});

// front__main--link--closeをクリックしたら front__main--linkを非表示に
// クリックイベントリスナーを追加
document.querySelector(".front__main--link--close")?.addEventListener("click", function () {
  // リンク要素を取得し、HTMLLinkElement型としてアサート
  const link = document.querySelector(".front__main--link") as HTMLLinkElement | null;
  
  // リンクが存在する場合のみ非表示にする
  if (link) {
    link.style.display = "none";
  }
});


//テキスト差し替え
// 名前のラベル要素を取得
const field_1_nameLabel: HTMLLabelElement | null = document.querySelector('label[for="wpforms-79-field_1"]');
const field_2_nameLabel: HTMLLabelElement | null = document.querySelector('label[for="wpforms-79-field_1-last"]');
const field_3_nameLabel: HTMLLabelElement | null = document.querySelector('label[for="wpforms-79-field_2"]');
const field_4_nameLabel: HTMLLabelElement | null = document.querySelector('label[for="wpforms-79-field_2-last"]');
// nameLabelがnullでないことを確認してから操作する
if (field_1_nameLabel) {
  // テキストを変更
  field_1_nameLabel.innerHTML = '姓<span class="wpforms-required-label">(必須)</span>';
}
if (field_2_nameLabel) {
  // テキストを変更
  field_2_nameLabel.innerHTML = '名<span class="wpforms-required-label">(必須)</span>';
}
if (field_3_nameLabel) {
  // テキストを変更
  field_3_nameLabel.innerHTML = '姓<span class="wpforms-required-label">(必須)</span>';
}
if (field_4_nameLabel) {
// テキストを変更
field_4_nameLabel.innerHTML = '名<span class="wpforms-required-label">(必須)</span>';
}


// 要素が画面内に入ったらclass付与
const left = document.querySelectorAll('.front__meet--photo.left');
const right = document.querySelectorAll('.front__meet--photo.right');
const frontfeaturelist = document.querySelectorAll('.front__feature--list');
const offset = 50; // 要素が画面上部から50px以内に来たら.activeクラスを追加する

function addActiveClass() {
  frontfeaturelist.forEach(item => {
    const rect = item.getBoundingClientRect();
    if (rect.top <= window.innerHeight - offset && rect.bottom >= offset) {
      item.classList.add('fadeIn');
    } else {
      item.classList.remove('fadeIn');
    }
  });

  left.forEach(item => {
    const rect = item.getBoundingClientRect();
    if (rect.top <= window.innerHeight - offset && rect.bottom >= offset) {
      item.classList.add('fadeUp');
    } else {
      item.classList.remove('fadeUp');
    }
  });

  right.forEach(item => {
    const rect = item.getBoundingClientRect();
    if (rect.top <= window.innerHeight - offset && rect.bottom >= offset) {
      item.classList.add('fadeDown');
    } else {
      item.classList.remove('fadeDown');
    }
  });
}

window.addEventListener('scroll', addActiveClass);

